/**
 * @description 全局Model teamModal 挂载到 redux 上
 */

import { APIS, PageableResultSingleArticleInfo } from '@src/services';
import {
  ParamsteamsTeamIdFollowUsingPost,
  ParamsteamsTeamIdUsingGet,
  ParamsteamsTeamIdLastUsingGet
} from '@src/services/api/TeamApi';
import { ParamsquestionQuestionIdCollectUsingPost } from '@src/services/api/QuestionApi';

import * as models from '@services/model/models';

import createModel, { Tction } from '@tkit/model';

import {
  HOME_ANSWER_AGREE_ACTION_TYPE,
  HOME_ANSWER_DISAGREE_ACTION_TYPE
} from '@src/utils/constant/home';

import { NETWORK_ERROR_TIP } from '@src/utils/constant/common';

import { message } from 'antd';

const agreeDisagreeNextMap = {
  [HOME_ANSWER_AGREE_ACTION_TYPE]: {
    0: { tip: '已赞同', agreeStatus: 1 },
    1: { tip: '已取消赞同', agreeStatus: 0 },
    2: { tip: '已赞同', agreeStatus: 1 }
  },
  [HOME_ANSWER_DISAGREE_ACTION_TYPE]: {
    0: { tip: '已反对', agreeStatus: 2 },
    1: { tip: '已反对', agreeStatus: 2 },
    2: { tip: '已取消反对', agreeStatus: 0 }
  }
};

export interface State {
  teamInfoModal: any;
  askListModel: PageableResultSingleArticleInfo;
  answerListModel: PageableResultSingleArticleInfo;
  newArticleListModel: PageableResultSingleArticleInfo;
  newArticleListLoading: boolean;
  askListLoading: boolean;
  answerListLoading: boolean;
}

export const teamModalState: State = {
  teamInfoModal: {},
  newArticleListModel: {},
  askListModel: {},
  answerListModel: {},
  newArticleListLoading: true,
  askListLoading: true,
  answerListLoading: true
};

const model = createModel({
  state: teamModalState,
  namespace: 'teamModal',
  reducers: {
    // 团队详情
    setTeamInfo: (state, action: Tction<{ teamInfoModal: any }>) => {
      return {
        ...state,
        teamInfoModal: action.payload.teamInfoModal
      };
    },
    // 获取最新文章
    setNewArticleList: (
      state,
      action: Tction<{ newArticleListModel: PageableResultSingleArticleInfo; pageNum: number }>
    ) => {
      const { newArticleListModel, pageNum } = action.payload;
      return {
        ...state,
        newArticleListModel: {
          ...newArticleListModel,
          list: newArticleListModel.list,
          pageNum: newArticleListModel.pageNum
        }
      };
    },

    // 获取提问
    setAskList: (state, action: Tction<{ askListModel: any; pageNum: number }>) => {
      const { askListModel, pageNum } = action.payload;
      return {
        ...state,
        askListModel: {
          ...askListModel,
          list: askListModel.list,
          pageNum: askListModel.pageNum
        }
      };
    },
    // 获取回答
    setAnswerList: (state, action: Tction<{ answerListModel: any; pageNum: number }>) => {
      const { answerListModel, pageNum } = action.payload;
      return {
        ...state,
        answerListModel: {
          ...answerListModel,
          list: answerListModel.list,
          pageNum: answerListModel.pageNum
        }
      };
    },
    // 重置页面数据
    setReset: state => {
      return {
        ...state,
        teamInfoModal: {},
        newArticleListModel: {},
        askListModel: {},
        answerListModel: {}
      };
    },
    // 更新loading状态
    updateLoading: (state, action: Tction<{ key: string; loading: boolean }>) => {
      const { key, loading } = action.payload;
      return {
        ...state,
        [key]: loading
      };
    },
    // 更新问题状态
    updateAskStatus: (state, action: Tction<{ questionIdVal: number; key: string; val: any }>) => {
      const { questionIdVal, key, val } = action.payload;
      const { askListModel } = state;
      const { list } = askListModel;
      return {
        ...state,
        askListModel: {
          ...askListModel,
          list:
            (list &&
              list.map((item: models.QuestionSimpleInfo) => {
                if (item.questionId === questionIdVal) {
                  return {
                    ...item,
                    [key]: val
                  };
                }
                return {
                  ...item
                };
              })) ||
            []
        }
      };
    },
    updateHomeAnswerAgreeDisagree: (
      state,
      action: Tction<{
        index: number;
        agreeStatus: number;
        agreeCount: number;
        disagreeCount: number;
      }>
    ) => {
      const { index, agreeStatus, agreeCount, disagreeCount } = action.payload;

      return {
        ...state,
        answerListModel: {
          ...state.answerListModel,
          list:
            state.answerListModel.list &&
            state.answerListModel.list.map((item: any, i: number) => {
              if (index === i) {
                return {
                  ...item,
                  agreeStatus: agreeStatus,
                  agreeCount: agreeCount,
                  disagreeCount: disagreeCount
                };
              }
              return item;
            })
        }
      };
    }
  },
  effects: {
    // 关注/取消关注团队
    *doJoinOrLeaveTeam(
      { tCall },
      action: Tction<{
        params: ParamsteamsTeamIdFollowUsingPost;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TeamApi.teamsTeamIdFollowUsingPost, action.payload.params);
      action.payload.callBack(res);
    },

    // 获取团队详情
    *getTeamById(
      { tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdUsingGet;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TeamApi.teamsTeamIdUsingGet, action.payload.params);
      if (res.code === 0) {
        yield tPut(model.actions.setTeamInfo, { teamInfoModal: res.result || {} });
        action.payload.callBack(res);
      }
    },
    // 获取最新文章
    *getNewArticleList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdLastUsingGet;
        type?: string;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, {
        key: 'newArticleListLoading',
        loading: true
      });
      const res = yield tCall(APIS.TeamApi.teamsTeamIdLastUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        key: 'newArticleListLoading',
        loading: false
      });
      const { code, result } = res;
      const { callBack, type } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setNewArticleList, {
          newArticleListModel: result,
          pageNum: action.payload.params.pageNum
        });
        callBack && callBack(result.total);
      }
    },
    // 获取问题
    *getAskList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdLastUsingGet;
        type?: string;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, {
        key: 'askListLoading',
        loading: true
      });
      const res = yield tCall(APIS.TeamApi.teamsTeamIdLastUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        key: 'askListLoading',
        loading: false
      });
      const { code, result } = res;
      const { callBack, type } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setAskList, {
          askListModel: result,
          pageNum: action.payload.params.pageNum
        });
        callBack && callBack(result.total);
      }
    },
    // 获取回答
    *getAnswerList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdLastUsingGet;
        type?: string;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, {
        key: 'answerListLoading',
        loading: true
      });
      const res = yield tCall(APIS.TeamApi.teamsTeamIdLastUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        key: 'answerListLoading',
        loading: false
      });
      const { code, result } = res;
      const { callBack, type } = action.payload;
      if (code === 0) {
        yield tPut(model.actions.setAnswerList, {
          answerListModel: result,
          pageNum: action.payload.params.pageNum
        });
        callBack && callBack(result.total);
      }
    },

    // 重置页面数据
    *reset({ tPut }): Iterator<{}, any, any> {
      yield tPut(model.actions.setReset);
    },
    // 问答关注
    *doFollowHomeQuestion(
      { tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdCollectUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { questionId, type }
      } = action.payload;
      const parmsObj = { questionIdVal: questionId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAskStatus, parmsObj);
      const res = yield tCall(APIS.QuestionApi.questionQuestionIdCollectUsingPost, params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateAskStatus, {
          questionIdVal: questionId,
          key: 'hasFollow',
          val: type
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAskStatus, parmsObj);
      callBack && callBack(res);
    },

    doAgreeDisagreeHomeAnswer: [
      function*(
        { tCall, tPut },
        action: Tction<{
          answerId: number;
          index: number;
          clickedType: string;
          currentType: number;
        }>
      ): Iterator<{}, any, any> {
        const { answerId, index, clickedType, currentType } = action.payload;
        const res = yield tCall(APIS.AnswerApi.answerAnswerIdAgreeUsingPost, {
          answerId,
          type: agreeDisagreeNextMap[clickedType][currentType].agreeStatus
        });
        if (res.code === 0 && res.result && Object.keys(res.result).length >= 2) {
          const { agreeCount = 0, disagreeCount = 0 } = res.result;
          yield tPut(model.actions.updateHomeAnswerAgreeDisagree, {
            index,
            agreeStatus: agreeDisagreeNextMap[clickedType][currentType].agreeStatus,
            agreeCount,
            disagreeCount
          });
          message.success(agreeDisagreeNextMap[clickedType][currentType].tip);
        } else {
          message.error(`${res.message || NETWORK_ERROR_TIP}`);
        }
      },
      {
        type: 'takeLatest'
      }
    ]
  }
});

export default model;
